<template>
    <div>
        <Modal v-model="show"
            :width="90"
            :footer-hide="true"
            title="产品审核"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch" />
                    </Col>
                </Row>
            </transition>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">未提交审批产品</span>
                            <Button type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                style="margin-left:30px;"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        </div>
                        <div class="right-bar">

                        </div>
                    </div>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="18">
                    <stand-pagination-table :columns="mainTable.tableColumns"
                        :data="mainTable.tableData"
                        :loading="mainTable.tableLoading"
                        :page-size-options="[5]"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getMainTableRecords" />
                    </Col>
                    <Col span="6">
                    <Card>
                        <Spin v-if="innerSpin"
                            size="large"
                            fix></Spin>
                        <p slot="title">已添加产品</p>
                        <Button type="success"
                            class="btns"
                            slot="extra"
                            size="small"
                            @click="onSubmit">提交</Button>
                        <Row :gutter="16">
                            <Col span="24">
                            <Tag v-for="p in productAddedList"
                                :key="p.productUuid"
                                :name="p.productUuid"
                                type="border"
                                closable
                                color="warning"
                                style="font-size:18px;"
                                @on-close="onRemoveAddedProduct">{{ p.productName }}（{{ p.productCode }}）</Tag>
                            </Col>
                        </Row>
                    </Card>

                    </Col>
                </Row>
            </Card>
        </Modal>

    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { singleImageRender } from '@/libs/tableRowImageRender';

import {
    getUnapprovedProductList,
    saveProductApprove
} from '@/api/modules/product-management/productApprove-management';

export default {
    name: 'ProductApproveCreate',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            mainTable: {
                tableColumns: [

                    { title: '大类', key: 'mainCategoryName', align: 'center' },
                    { title: '小类', key: 'subCategoryName', align: 'center' },
                    { title: '品牌', key: 'brandName', align: 'center' },
                    { title: '系列', key: 'serialName', align: 'center' },
                    { title: '名称', key: 'productName', align: 'center' },
                    { title: '标准卡', key: 'standardCardName', align: 'center' },
                    { title: '销售期限', key: 'productSalesPeriod', align: 'center' },
                    { title: '成品图', align: 'center', render: (h, params) => singleImageRender(h, params.row.productFinishImageFile) },
                    {
                        title: '申请说明',
                        align: 'left',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.productApproveDetailRequestRemark
                                },
                                on: {
                                    'on-change': event => {
                                        this.mainTable.tableData[params.index].productApproveDetailRequestRemark = event.target.value;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        ghost: true,
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.onAddProduct(params.row);
                                        }
                                    }
                                }, '添加')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '名称', type: 'Input', value: '', name: 'productName', sql: 'like' }
                ]
            },
            productAddedList: []
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.mainTable.tableSearch.limit.conditions.pageLength = 5;

            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getUnapprovedProductList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records.map(r => {
                        return Object.assign(r, { productApproveDetailRequestRemark: '' });
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onAddProduct(productRow) {
            const find = this.productAddedList.find(p => p.productUuid === productRow.productUuid);
            if (!find) {
                this.productAddedList.push(productRow);
            }
        },
        onRemoveAddedProduct(event, name) {
            const findIndex = this.productAddedList.findIndex(p => p.productUuid === name);
            if (findIndex >= 0) {
                this.productAddedList.splice(findIndex, 1);
            }
        },
        onSubmit() {
            if (this.productAddedList.length === 0) {
                this.$Message.error('请先添加需要审核的产品');
                return;
            }

            const submitProductUuidList = this.productAddedList.map(p => {
                return {
                    productUuid: p.productUuid,
                    productTag: `${p.productName}（${p.productCode}）`,
                    productApproveDetailRequestRemark: p.productApproveDetailRequestRemark
                };
            });

            const submitData = {
                products: submitProductUuidList
            };

            this.innerSpin = true;
            saveProductApprove(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.productAddedList = [];
                            this.init();
                            // this.$router.push({ name: 'productApprove-list' });
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
